import React, { useState } from "react";
import { Controller } from "react-hook-form";
import InputError from "./InputError";
import { setNamewithLocale } from "../../helpers/forms";
import { Col } from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ContentEditor = ({
	name,
	langId = name,
	locale,
	rules = { required: "مطلوب" },
	errors,
	control,
	lg = "12",
	values,
	key = 0,
}) => {
	const dir = locale === "ar" ? "rtl" : "ltr";
	const [firstLoad, setFirstLoad] = useState(true);

	return (
		<Col lg={lg}>
			<div className={`form-group ${rules?.required ? "required" : ""}`}>
				<Controller
					control={control}
					render={({ field: { value, onChange } }) => (
						<ReactQuill
							key={key}
							value={firstLoad ? value || "" : value}
							onChange={content => {
								setFirstLoad(false);
								onChange(content);
							}}
							modules={{
								toolbar: [
									[{ header: [1, 2, false] }],
									["bold", "italic", "underline", "strike"],
									[{ align: [] }],
									[{ list: "ordered" }, { list: "bullet" }],
									["blockquote", "code-block"],
									[{ direction: dir }],
									["link", "image", "video"],
									["clean"],
								],
							}}
							formats={[
								"header",
								"bold",
								"italic",
								"underline",
								"strike",
								"align",
								"list",
								"blockquote",
								"code-block",
								"direction",
								"link",
								"image",
								"video",
							]}
							style={{ height: "300px" }}
						/>
					)}
					name={setNamewithLocale(name, locale)}
					rules={rules}
				/>

				<InputError name={name} locale={locale} errors={errors} />
			</div>
		</Col>
	);
};

export default ContentEditor;
